module.exports = "/packs/media/images/young_family-379acd47f81a4c26f56fcc74746eb5d2.png";